import React from 'react';

export const PrimarySection: React.FC = ({ children }) => <div className="py-5 md:py-12">{children}</div>;

export const SecondarySection: React.FC = ({ children }) => <div className="py-4 md:py-6">{children}</div>;
